import worker from './worker';

const module = {
    worker,
};

export default module;
